import { Icon3x2Landscape } from '@picsart/design-system/foundation/icons/Icon3x2Landscape';
import { Icon3x2Portrait } from '@picsart/design-system/foundation/icons/Icon3x2Portrait';
import { IconCrownOutline } from '@picsart/design-system/foundation/icons/IconCrownOutline';
import { IconNoCommercial } from '@picsart/design-system/foundation/icons/IconNoCommercial';
import { IconSquare } from '@picsart/design-system/foundation/icons/IconSquare';
import { FiltersDataType, FiltersTypes } from './types';

export const colorsData = {
  queryName: FiltersTypes.colors,
  title: 'Color',
  options: [
    { label: 'Purple', value: 'purple' },
    { label: 'Blue', value: 'blue' },
    { label: 'Red', value: 'red' },
    { label: 'Pink', value: 'pink' },
    { label: 'Green', value: 'green' },
    { label: 'Orange', value: 'orange' },
    { label: 'Yellow', value: 'yellow' },
    { label: 'Brown', value: 'brown' },
    { label: 'Black', value: 'black' },
    { label: 'Gray', value: 'gray' },
    { label: 'White', value: 'white' },
  ],
};

export const subCategoriesData = {
  queryName: FiltersTypes.subCategories,
  title: 'Subcategories',
};

export const typesData = {
  queryName: FiltersTypes.type,
  title: 'Type',
  options: [
    {
      label: 'Static',
      value: 'static',
    },
    {
      label: 'Animated',
      value: 'animated',
    },
  ],
};

export const priceData = {
  queryName: FiltersTypes.price,
  title: 'Price',
  options: [
    {
      label: 'Free',
      startIcon: IconNoCommercial,
      value: 'free',
    },
    {
      label: 'Premium',
      startIcon: IconCrownOutline,
      value: 'premium',
    },
  ],
};

export const orientationData = {
  queryName: FiltersTypes.orientations,
  title: 'Orientation',
  options: [
    {
      label: 'Landscape',
      value: 'landscape',
      startIcon: Icon3x2Landscape,
    },
    {
      label: 'Square',
      value: 'square',
      startIcon: IconSquare,
    },
    {
      label: 'Portrait',
      value: 'portrait',
      startIcon: Icon3x2Portrait,
    },
  ],
};

// Landscape, Square, Portrait

export const sizesData = {
  title: 'Sizes',
  queryName: FiltersTypes.size,
  options: [
    { label: 'A0', value: 'a0' },
    { label: 'A1', value: 'a1' },
    { label: 'A2', value: 'a2' },
    { label: 'A3', value: 'a3' },
    { label: 'A4', value: 'a4' },
    { label: 'A5', value: 'a5' },
    { label: 'A6', value: 'a6' },
    { label: 'A7', value: 'a7' },
    { label: 'DL', value: 'dl' },
    { label: 'Business Card', value: 'business card' },
    { label: 'Legal', value: 'legal' },
    { label: 'Letter', value: 'letter' },
    { label: 'Tabloid', value: 'tabloid' },
  ],
};

export const themesData = {
  title: 'Theme',
  queryName: FiltersTypes.theme,
  options: [
    { label: 'Animals', value: 'animals' },
    { label: 'Anime', value: 'anime' },
    { label: 'Architecture', value: 'architecture' },
    { label: 'Art', value: 'art' },
    { label: 'Beauty', value: 'beauty' },
    { label: 'Business', value: 'business' },
    { label: 'Characters', value: 'characters' },
    { label: 'Concept', value: 'concept' },
    { label: 'Crime', value: 'crime' },
    { label: 'Dance', value: 'dance' },
    { label: 'Drinks', value: 'drinks' },
    { label: 'Education', value: 'education' },
    { label: 'Emoji', value: 'emoji' },
    { label: 'Emotions', value: 'emotions' },
    { label: 'Entertainment', value: 'entertainment' },
    { label: 'Events', value: 'events' },
    { label: 'Family', value: 'family' },
    { label: 'Fantasy', value: 'fantasy' },
    { label: 'Fashion', value: 'fashion' },
    { label: 'Fitness', value: 'fitness' },
    { label: 'Flowers', value: 'flowers' },
    { label: 'Food', value: 'food' },
    { label: 'Gaming', value: 'gaming' },
    { label: 'Healthcare', value: 'healthcare' },
    { label: 'Home', value: 'home' },
    { label: 'Humor', value: 'humor' },
    { label: 'Lifestyle', value: 'lifestyle' },
    { label: 'Marketing', value: 'marketing' },
    { label: 'Memes', value: 'memes' },
    { label: 'Motivational', value: 'motivational' },
    { label: 'Music', value: 'music' },
    { label: 'Nature', value: 'nature' },
    { label: 'Objects', value: 'objects' },
    { label: 'People', value: 'people' },
    { label: 'Personal', value: 'personal' },
    { label: 'Pets', value: 'pets' },
    { label: 'Printable', value: 'printable' },
    { label: 'Retail', value: 'retail' },
    { label: 'Seasons', value: 'seasons' },
    { label: 'Shape', value: 'shape' },
    { label: 'Social Media', value: 'social media' },
    { label: 'Space', value: 'space' },
    { label: 'Sports', value: 'sports' },
    { label: 'Styled Fonts', value: 'styled fonts' },
    { label: 'Symbols', value: 'symbols' },
    { label: 'Trendy', value: 'trendy' },
    { label: 'Travel', value: 'travel' },
    { label: 'Wellness', value: 'wellness' },
  ],
};

export type BaseFilters = Exclude<FiltersTypes, 'subCategories'>;

export const filters: {
  [key in BaseFilters]: FiltersDataType;
} = {
  [FiltersTypes.theme]: themesData,
  [FiltersTypes.orientations]: orientationData,
  [FiltersTypes.price]: priceData,
  [FiltersTypes.colors]: colorsData,
  [FiltersTypes.size]: sizesData,
  [FiltersTypes.type]: typesData,
};
export const ClearAll = 'Clear all';
export const Clear = 'Clear';
export const Apply = 'Apply';

export const mobileContainerSpacing = 60;
